import { render, staticRenderFns } from "./youmo.vue?vue&type=template&id=2dff541e&scoped=true"
import script from "./youmo.vue?vue&type=script&lang=js"
export * from "./youmo.vue?vue&type=script&lang=js"
import style0 from "./youmo.vue?vue&type=style&index=0&id=2dff541e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff541e",
  null
  
)

export default component.exports